import useProdGroups from "src/hooks/product-groups/useProdGroups";

export default function useProductTabs() {
  const { data: prodGroup } = useProdGroups({
    sortOrder: "asc",
    sortField: "order",
  });

  const productTab = [
    ...(prodGroup?.data?.map((v) => ({
      id: v?._id,
      name: v?.name,
      tab: v?.order,
      tabId: v?._id,
      type: v?.type,
    })) || []),
  ];
  return productTab;
}
